import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import { addPrefixPath } from '@serpro/volto-prefixpath/helpers/Url/Url';

const getVideoFileMimeType = (file) =>
  file?.['content-type'] ||
  file?.content_type ||
  file?.contentType ||
  'video/mp4';

export const getVideoFileSource = (file) => {
  if (!file) return null;

  if (file.download) {
    return addPrefixPath(file.download);
  }

  if (file['@id']) {
    return addPrefixPath(file['@id']);
  }

  if (file.data) {
    const encoding = file.encoding || 'base64';
    const mimeType = getVideoFileMimeType(file);
    return `data:${mimeType};${encoding},${file.data}`;
  }

  return null;
};

export const getPreviewImageURL = (previewImage) => {
  if (!previewImage) return null;

  return isInternalURL(previewImage)
    ? previewImage.includes('@@images')
      ? previewImage
      : `${flattenToAppURL(previewImage)}/@@images/image`
    : previewImage;
};
